// TODO: remove .filter-item references
import Scroll from './Scroll';
import IsMobile from './IsMobile';
export default (($) => {
    console.log('UNTUCKit : Module : Filter : loaded');
    const $window = $(window), $body = $('body'), $bindTo = $('.templateCollection');
    let isMobile = false;
    const setPath = function () {
        setURLParams();
    };
    const bindUIActions = function () {
        $bindTo.off('click');
        $window.on('resize', function () {
            if (isMobile && !IsMobile.check(1173)) {
                Scroll.unlock();
                isMobile = false;
            }
            else if (!isMobile && IsMobile.check(1173)) {
                isMobile = true;
            }
        });
        $body.on('click', function () {
            if (!isMobile) {
                $('.toggle-wrap').removeClass('is-active');
            }
        });
        $bindTo.on('click', '.filter.toggle-target', function (e) {
            e.stopPropagation();
        });
        $bindTo.on('click', '.js-toggle-trigger', function (e) {
            console.log('.js-toggle-trigger clicked');
            const $tar = $(this).parent();
            e.stopPropagation();
            if ($tar.hasClass('is-active')) {
                $tar.removeClass('is-active');
                $(this).attr('aria-expanded', "false");
            }
            else {
                $(this).attr('aria-expanded', "true");
                $tar.addClass('is-active').siblings('.toggle-wrap').removeClass('is-active');
            }
            return false;
        });
        $bindTo.on('click', '.js-toggle-sort', function () {
            $(this).parents('.toggle-wrap').removeClass('is-active');
            Scroll.unlock();
        });
        $bindTo.on('click', '.sort-item', function () {
            const $this = $(this), newText = $this.text();
            $this.parent().prev().trigger('click').find('span:eq(0)').text(newText);
        });
        $bindTo.on('click', '.js-heading', function (e) {
            if (IsMobile.check(1173)) {
                $(this).toggleClass('is-active').next().slideToggle();
                e.stopPropagation();
            }
        });
        $bindTo.on('click', '.js-apply', function () {
            setPath();
            $(this).parents('.toggle-wrap').removeClass('is-active');
            Scroll.unlock();
        });
        $bindTo.on('click', '.js-clear', function () {
            const $scope = $(this).parents('.toggle-target');
            $('.js-remove-filter').remove();
            $scope.parent().removeClass('is-active');
            Scroll.unlock();
        });
    };
    const setURLParams = function (key, value) {
        if (typeof key == 'undefined') {
            history.pushState({ 'title': document.title }, document.title, window.location.href.split('?')[0]);
            return;
        }
        const url = window.location.href, urlConnect = window.location.search == '' ? '?' : '&', newUrl = url + urlConnect + key + '=' + value;
        history.pushState({ 'title': document.title }, document.title, newUrl);
        return;
    };
    function init() {
        console.log('UNTUCKit : Module : Filter : init');
        isMobile = IsMobile.check(1173);
        if ($('.mix-container').length) {
            bindUIActions();
            $('.filter-bar').removeClass('is-disabled');
        }
    }
    return {
        init
    };
})($);
